// Share button for the reveal screen. Native share sheet on phones (where most
// viral traffic lands), clipboard copy on desktop. Both are the browser's own
// APIs — no third-party share widgets, so content/privacy.md's "no social-media
// pixel" claim stays true. Capabilities are injected so this is unit-testable.

export const SHARE_TEXT = "I rated real policies without knowing which party backed them to understand better whose policies I actually support. See which party's ideas you actually agree with.";

export interface ShareCapabilities {
  share?: (data: { title: string; text: string; url: string }) => Promise<void>;
  writeText?: (text: string) => Promise<void>;
}

export type ShareOutcome = "shared" | "cancelled" | "copied" | "failed";

export async function shareResult(url: string, caps: ShareCapabilities): Promise<ShareOutcome> {
  if (caps.share) {
    try {
      await caps.share({ title: "Whose Policy Is It", text: SHARE_TEXT, url });
      return "shared";
    } catch (err) {
      // Dismissing the sheet isn't an error worth a second UI.
      if (err instanceof Error && err.name === "AbortError") return "cancelled";
    }
  }
  if (caps.writeText) {
    try {
      await caps.writeText(url);
      return "copied";
    } catch {
      // fall through
    }
  }
  return "failed";
}

/** Capabilities from the real browser; absent APIs stay undefined. */
export function browserShareCapabilities(): ShareCapabilities {
  return {
    share: typeof navigator.share === "function" ? (d) => navigator.share(d) : undefined,
    writeText: navigator.clipboard?.writeText ? (t) => navigator.clipboard.writeText(t) : undefined,
  };
}
